(function() {
  var gallery = document.querySelector('gallery-carousel');
  if (!gallery) return;
  // Gallery-level fade removed — per-image reveal in jb-global-cards.css
  // handles the elegant fade once each image's styling is final.
})();
